export default "__VITE_ASSET__BdxmKFIf__"